import axios from 'axios';
import { BASEURL } from '../../baseUrl';
import { toast } from 'react-toastify';

export const GET_ADMINS = 'GET_ADMINS';
export const GET_ADMIN_MANAGER = 'GET_ADMIN_MANAGER';
export const GET_EXPIRED_ADMINS = 'GET_EXPIRED_ADMINS';
export const DASHBOARD_COUNTS = 'DASHBOARD_COUNTS';
export const ADD_SUBADMIN = 'ADD_SUBADMIN';
export const UPDATE_SUBADMIN = 'UPDATE_SUBADMIN';
export const DELETE_SUBADMIN = 'DELETE_SUBADMIN';

export const ADD_SUPER_ADMIN = 'ADD_SUPER_ADMIN';
export const DELETE_SUPER_ADMIN = 'DELETE_SUPER_ADMIN';
export const UPDATE_SUPER_ADMIN = 'UPDATE_SUPER_ADMIN';
export const GET_SUPER_ADMIN = 'GET_SUPER_ADMIN';
export const GET_ALL_SUPER_ADMINS = 'GET_ALL_SUPER_ADMINS';

const getAdminsAction = (payload) => ({ type: GET_ADMINS, payload: payload });
const getAdminManagerAction = (payload) => ({
  type: GET_ADMIN_MANAGER,
  payload: payload,
});
const getExpiredAdminsAction = (payload) => ({
  type: GET_EXPIRED_ADMINS,
  payload: payload,
});
const getDashboardCountsAction = (payload) => ({
  type: DASHBOARD_COUNTS,
  payload: payload,
});
const addSubAdminAction = (payload) => ({
  type: ADD_SUBADMIN,
  payload: payload,
});
const updateSubAdminAction = (payload) => ({
  type: UPDATE_SUBADMIN,
  payload: payload,
});
const deleteSubAdminAction = (payload) => ({
  type: DELETE_SUBADMIN,
  payload: payload,
});

const addSuperAdminAction = (payload) => ({ type: ADD_SUPER_ADMIN, payload });
const deleteSuperAdminAction = (payload) => ({
  type: DELETE_SUPER_ADMIN,
  payload,
});
const updateSuperAdminAction = (payload) => ({
  type: UPDATE_SUPER_ADMIN,
  payload,
});
const getSuperAdminAction = (payload) => ({ type: GET_SUPER_ADMIN, payload });
const getAllSuperAdminsAction = (payload) => ({
  type: GET_ALL_SUPER_ADMINS,
  payload,
});

export const getAdmins = (payload) => {
  return async (dispatch) => {
    try {
      const queryParams = new URLSearchParams({
        page: payload?.page || 1,
        limit: payload?.limit || 10,
        search: payload?.search || '',
      });

      if (payload?.planId && payload.planId !== '') {
        queryParams.append('planId', payload.planId);
      }

      await axios
        .get(`${BASEURL}/superAdmin/getAllAdmins?${queryParams}`)
        .then((res) => {
          dispatch(getAdminsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getAdminsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error fetching admins:', error);
    }
  };
};

export const getAdminManager = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/superAdmin/getManagers?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}`,
        )
        .then((res) => {
          dispatch(getAdminManagerAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getAdminManagerAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const getExpiredAdmins = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .get(
          `${BASEURL}/superAdmin/expired-admins?page=${payload?.page}&limit=${payload?.limit}&search=${payload?.search}&planId=${payload?.planId}`,
        )
        .then((res) => {
          dispatch(getExpiredAdminsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getExpiredAdminsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const getDashboardCounts = (payload) => {
  return async (dispatch) => {
    try {
      await axios
        .get(`${BASEURL}/superAdmin/dashboard`)
        .then((res) => {
          dispatch(getDashboardCountsAction(res));
        })
        .catch((error) => {
          console.log('Error', error);
          dispatch(getDashboardCountsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response);
      console.log('Error login user:', error);
    }
  };
};

export const addSubAdmin = (data, params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${BASEURL}/subAdmin/registerSubAdmin`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (res?.data?.success) {
        toast.success(res.data.message);
      }
      dispatch(addSubAdminAction(res));
      dispatch(getAdmins(params));
      return res;
    } catch (error) {
      const detailedMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        'Something went wrong';
      toast.error(detailedMessage);
      dispatch(addSubAdminAction(error?.response));
      console.log('Error adding subadmin:', error);
      return error?.response;
    }
  };
};

export const updateSubAdmin = (id, data, params) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .put(`${BASEURL}/subAdmin/updateSubAdmin/${id}`, data, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res.data.message);
          }
          dispatch(updateSubAdminAction(res));
          dispatch(getAdmins(params));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(updateSubAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error updating subadmin:', error);
    }
  };
};

export const deleteSubAdmin = (id, params) => {
  return async (dispatch) => {
    try {
      await axios
        .delete(`${BASEURL}/subAdmin/deleteSubAdmin/${id}`)
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res.data.message);
          }
          dispatch(deleteSubAdminAction(res));
          dispatch(getAdmins(params));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(deleteSubAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error deleting subadmin:', error);
    }
  };
};

export const addSuperAdmin = (data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .post(`${BASEURL}/superAdmin/add-superadmin`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res.data.message);
          }
          dispatch(addSuperAdminAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(addSuperAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error adding super admin:', error);
    }
  };
};

export const deleteSuperAdmin = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .delete(`${BASEURL}/superAdmin/delete-superadmin/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res.data.message);
          }
          dispatch(deleteSuperAdminAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(deleteSuperAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error deleting super admin:', error);
    }
  };
};

export const updateSuperAdmin = (id, data) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .put(`${BASEURL}/superAdmin/update-superadmin/${id}`, data, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          if (res?.data?.success) {
            toast.success(res.data.message);
          }
          dispatch(updateSuperAdminAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(updateSuperAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error updating super admin:', error);
    }
  };
};

export const getSuperAdminById = (id) => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/superAdmin/get-superadmin/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getSuperAdminAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(getSuperAdminAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error getting super admin:', error);
    }
  };
};

export const getAllSuperAdmins = () => {
  return async (dispatch) => {
    try {
      const token = localStorage.getItem('token');
      await axios
        .get(`${BASEURL}/superAdmin/get-all-superadmins`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((res) => {
          dispatch(getAllSuperAdminsAction(res));
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || 'Something went wrong');
          dispatch(getAllSuperAdminsAction(error?.response));
        });
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Something went wrong');
      console.log('Error getting all super admins:', error);
    }
  };
};
